import dayjs from 'dayjs'
import type { DuplicateReviewComparison, DuplicateReviewSummary } from '@/hooks/usePatientMerge'
import { formatPhoneDisplay } from '@/utils/formatPhone'

// Display vocabulary shared by the review page, its columns and the confirmation modal.

export type ComparisonRecord = DuplicateReviewComparison['records'][number]
export type RecordSummary = DuplicateReviewSummary['records'][number]
export type MergeField = DuplicateReviewComparison['differingFields'][number]

/** Index into the comparison's `records` pair. */
export type RecordIndex = 0 | 1

export const formatDate = (value: string | undefined): string =>
  value ? dayjs(value).format('MMM D, YYYY') : ''

export const FIELD_LABELS: Record<MergeField, string> = {
  name: 'Name',
  birthDate: 'Date of birth',
  gender: 'Gender',
  phone: 'Phone',
  email: 'Email',
  address: 'Address',
}

const NOT_RECORDED = 'Not recorded'

export function formatFieldValue(
  field: MergeField,
  demographics: ComparisonRecord['demographics'],
): string {
  const value = demographics[field]
  if (!value) return NOT_RECORDED
  if (field === 'birthDate') return formatDate(value)
  if (field === 'phone') return formatPhoneDisplay(value)
  if (field === 'gender') return value.charAt(0).toUpperCase() + value.slice(1)
  return value
}
